"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { RowTitle } from "./RowTitle";
import { DataRow } from "./DataRow";
import { ChildRow } from "./LayoutDataTable";
import { Icon } from "@/components/formatters/MXPIcon";
export interface DataTableGroupRowProps {
  title: string;
  childRows: ChildRow[];
  isExpandedByDefault?: boolean;
  columnCount: number;
  tableType?: "basic" | "grouped";
}
const toggleClasses = ["flex items-center gap-2 outline-none border-none", "text-left py-4 px-5 sticky left-0 z-[2]", "bg-transparent cursor-pointer", "t2-dark:text-white t2-dark:bg-gray-m5"].join(" ");
const groupTitleClasses = ["text-gray-m10 font-semibold", "text-base sm:text-lg", "leading-[1.375rem] sm:leading-8", "tracking-normal sm:tracking-[0.18px]", "t2-dark:text-white"].join(" ");
export const GroupRow = t0 => {
  const $ = _c(20);
  const {
    title,
    childRows,
    isExpandedByDefault,
    columnCount,
    tableType: t1
  } = t0;
  const tableType = t1 === undefined ? "grouped" : t1;
  const [expanded, setExpanded] = useState(isExpandedByDefault);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setExpanded(_temp);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = expanded ? "90" : "270";
  let t4;
  if ($[1] !== t3) {
    t4 = <Icon type="t2u-chevron-right" rotateDeg={t3} size={12} fillColor="#000" label="Data Table Group Row Dropdown" className="transition-transform duration-200 ease-in-out" />;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== title) {
    t5 = <span className={groupTitleClasses}>{title}</span>;
    $[3] = title;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== expanded || $[6] !== t4 || $[7] !== t5) {
    t6 = <div className="min-w-full bg-gray-m1 border-b border-gray-m2 t2-dark:bg-gray-m5 t2-dark:border-b-white"><button className={toggleClasses} onClick={t2} aria-expanded={expanded}>{t4}{t5}</button></div>;
    $[5] = expanded;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== columnCount || $[10] !== t6) {
    t7 = <tr className="t2-dark:bg-gray-m5"><td colSpan={columnCount} className="p-0 t2-dark:bg-gray-m5 t2-dark:text-white">{t6}</td></tr>;
    $[9] = columnCount;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== childRows || $[13] !== columnCount || $[14] !== expanded || $[15] !== tableType) {
    t8 = expanded && childRows?.map((row, index) => {
      if (row?.type === "rowTitle") {
        return <RowTitle key={index} title={row?.title} titleUrl={row?.titleUrl} columnCount={columnCount} />;
      }
      if (row?.type === "rowData") {
        return <DataRow key={index} dataCells={row?.dataCells} columnCount={columnCount} tableType={tableType} />;
      }
      return null;
    });
    $[12] = childRows;
    $[13] = columnCount;
    $[14] = expanded;
    $[15] = tableType;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
function _temp(prev) {
  return !prev;
}